// src/services/messages.js
import api from '../services/api';
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

/**
 * Récupère les messages d'une discussion spécifique
 * @param {string} discussionId - ID de la discussion
 * @returns {Promise<Array>} - Liste des messages
 */
export async function fetchMessagesForDiscussion(discussionId) {
  try {
    const response = await api.get(
      `/api/messages/${discussionId}/messages`
    );

    return response.data.messages || response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des messages:", error);
    return [];
  }
}